module.exports = __webpack_public_path__ + "img/biography-border-logo.92572791.png";